/**
 * Created by woo on 01/06/2017.
 */

import React from 'react'
import queryString from 'query-string'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import Loader from '../../components/Loader/index'

class Wechat extends React.Component {
  static defaultProps = {
    scanSuccess: true,
  }

  componentDidMount() {
    const query = queryString.parse(this.props.location.search)
    this.code = query.code || 0
    this.state = query.state || 0
    this.props.fetchScan(this.code, this.state)
  }

  render() {
    return <div>{this.props.scanSuccess && <Loader />}</div>
  }
}

const mapStateToProps = (state) => {
  return {
    scanSuccess: state.getWechat.scanSuccess,
  }
}
export default withRouter(connect(mapStateToProps, actions)(Wechat))



// WEBPACK FOOTER //
// ./src/containers/WechatAuth/index.js